import { BaseHttpProvider } from "./base-http.provider"

export interface SearchRequestCreationData {
  locale: string
  query: string
  type: "faq" | "journal"
}

export class SearchProvider extends BaseHttpProvider {
  async create(data: SearchRequestCreationData) {
    const response = await this.execute({
      uri: "/searches",
      method: "POST",
      data,
    })

    return response
  }
}
